module.exports = __webpack_public_path__ + "media/svg-new/svg-bot-8b71fe5b.svg";